import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { DATE_RANGES } from '../../common/constants';
import typesTypes from './prop-types';
import Diff from '../../common/diff';
import { Num } from './styles';

const Container = styled.div`
  min-width: 52px;
  margin-left: 12px;
  align-items: flex-end;

  &&&&& > .header {
    flex-direction: column;
    align-items: flex-end;
    color: ${props => props.theme.secondaryColor};
    > .main {
      height: 16px;
    }
    > .secondary {
      font-size: 10px;
      line-height: 16px;
    }
  }

  &&& > .values {
    display: flex;
    justify-content: flex-end;

    :before {
      display: block;
      order: -1;
      content: "";
      height: 100%;
      flex-grow: 2;
    }

    :after {
      display: block;
      order: 1;
      content: "";
      height: 100%;
      width: 4px;
    }

    > .wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;

      > .grey {
        ${Num};
        color: ${props => props.theme.secondaryColor};
      }

      > .diff {
        /**
         * The alignment of 'Diff' doesn't go well with flex-end. The
         * center and top padding is to fake that. The top padding value
         * is closely related to 'rowHeight' in type-grid.jsx.
         */
        padding-top: 10px;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        > span:first-child {
          margin-left: 0;
          margin-right: 6px;
        }
      }
    }
  }
`;

const Text = ({ isAllTime, diff }) => {
  if (isAllTime) {
    return <span className="cell grey">-</span>;
  }

  if (!diff) {
    return <span className="cell" />;
  }

  return (
    <div className="cell diff">
      <Diff value={diff} suffix="%" />
    </div>
  );
};

Text.propTypes = {
  isAllTime: PropTypes.bool.isRequired,
  diff: PropTypes.number.isRequired,
};

export default function VsPrev({ types, daysAgo }) {
  const isAllTime = !Number.isFinite(daysAgo);

  const dateName = React.useCallback(
    () => _.find(DATE_RANGES, { value: daysAgo }).label,
    [daysAgo],
  );

  return (
    <Container>
      <div className="header">
        <span className="main">vs prev</span>
        {!isAllTime && <span className="secondary">{dateName()}</span>}
      </div>
      <div className="values">
        <div className="wrapper">
          {types.map(({ type, diff }) => <Text {...{ isAllTime, diff, key: type }} />)}
        </div>
      </div>
    </Container>
  );
}

VsPrev.propTypes = {
  types: typesTypes.isRequired,
  daysAgo: PropTypes.number.isRequired,
};
